import { ThemeProvider } from "@mui/material/styles";
import { Outlet } from "react-router-dom";
import { adminTheme } from "./theme";

// Admin route paths kept as exported constants so navigation/redirect call sites
// elsewhere (e.g., `useNavigate(ADMIN_PATH)`) reference one literal instead of
// duplicating "/admin".
export const ADMIN_PATH = "/admin" as const;
export const IMPACT_REPORT_PATH = "/impact-report" as const;

// `studentTheme` is the implicit default — it's provided at the app root in
// `src/index.tsx` and applies to anything not nested inside a theme layout
// route. `AdminThemeLayout` is the structural override: any route placed inside
// it renders under `adminTheme`. Because React Router can only render one
// matching layout per URL, there is no second list to drift against — the route
// tree itself is the source of truth for theming.
//
// To add a new themed area in the future (e.g., a marketing or embed theme),
// export a new layout component here and wrap the relevant routes in it.
export function AdminThemeLayout(): JSX.Element {
  return (
    <ThemeProvider theme={adminTheme}>
      <Outlet />
    </ThemeProvider>
  );
}
